import { makeStyles } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(() => ({
  // GR-10779 Figma: 40x21 grey pill with white 10px semibold uppercase text.
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    height: 21,
    padding: '0 6px',
    borderRadius: 4,
    background: '#BEC6D6',
    color: '#FFFFFF',
    fontFamily: 'Dazzed',
    fontSize: 10,
    fontWeight: 600,
    lineHeight: 1,
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    userSelect: 'none'
  }
}))

const BetaBadge = ({ className = '' }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  return <span className={[classes.root, className].join(' ')}>{t('general.beta')}</span>
}

export default BetaBadge
